import { render, staticRenderFns } from "./ExCallCenter.vue?vue&type=template&id=78dbe2a2&scoped=true"
import script from "./ExCallCenter.vue?vue&type=script&lang=js"
export * from "./ExCallCenter.vue?vue&type=script&lang=js"
import style0 from "./ExCallCenter.vue?vue&type=style&index=0&id=78dbe2a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dbe2a2",
  null
  
)

export default component.exports